import { motion } from 'framer-motion'
import PropTypes from 'prop-types'
import React from 'react'
import ArrowIcon from '../../../assets/icons/arrow-right.svg'
import { pointRightVariants } from '../../animations/variants'
import PageLink from '../PageLink'
import './styles.scss'

const JobList = ({ jobs }) => (
  <ul className="job-list">
    {jobs.map((job, index) => (
      <motion.li className="job-list__item" key={index} initial="initial" whileHover="hover">
        <PageLink to={'/jobs/' + job.slug} display="block">
          <div className="job-list__item__inner">
            <div className="job-list__item__details">{job.title}</div>
            <motion.div className="job-list__item__icon" variants={pointRightVariants}>
              <ArrowIcon />
            </motion.div>
          </div>
        </PageLink>
      </motion.li>
    ))}
  </ul>
)

JobList.propTypes = {
  jobs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string
    })
  )
}

export default JobList
